export default {
    computed: {
        getNotifyType () {
            return [{
                value: 1,
                label: '所有'
            }, {
                value: 2,
                label: '仅当前'
            }, {
                value: 3,
                label: '仅下属组织'
            }]
        },
        getFormat () {
            return [
            {
                value: 0,
                label: '未设定'
            },
            {
                value: 1,
                label: '文本'
            },
            {
                value: 2,
                label: 'MarkDown'
            },
            {
                value: 3,
                label: 'HTML'
            }
            ]
        }
    }
}